var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNorwegian(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    id: "svg2",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3053"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 480,
    id: "rect3055",
    ry: 48,
    style: {
      fill: "#f1c40f",
      fillOpacity: 1,
      stroke: "none"
    },
    width: 480,
    x: 16.000015,
    y: 556.36218
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath3853"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m -360,118 a 208,208 0 1 1 -416,0 208,208 0 1 1 416,0 z",
    id: "path3855",
    style: {
      fill: "#f1c40f",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(1.1538462,0,0,1.1538462,911.38466,660.20833)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-540.36218)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clipPath3853)",
    id: "g2997",
    transform: "translate(-1.5258789e-5,-2.6171874e-6)"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 480,
    id: "rect3017",
    style: {
      fill: "#e32d3c",
      fillOpacity: 1,
      stroke: "none"
    },
    width: 480,
    x: 16,
    y: 556.36218
  }), /*#__PURE__*/React.createElement("rect", {
    height: 480,
    id: "rect3787",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    },
    width: 99,
    x: 144.43622,
    y: 556.36218
  }), /*#__PURE__*/React.createElement("rect", {
    height: 480,
    id: "rect3797",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0,1,-1,0,0,0)",
    width: 99,
    x: 746.86218,
    y: -496.00003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 480,
    id: "rect3799",
    style: {
      fill: "#2980b9",
      fillOpacity: 1,
      stroke: "none"
    },
    transform: "matrix(0,1,-1,0,0,0)",
    width: 45,
    x: 773.86218,
    y: -496.00003
  }), /*#__PURE__*/React.createElement("rect", {
    height: 480,
    id: "rect3789",
    style: {
      fill: "#2980b9",
      fillOpacity: 1,
      stroke: "none"
    },
    width: 45,
    x: 171.43622,
    y: 556.36218
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorwegian);
export default __webpack_public_path__ + "static/media/norwegian.6cc39bbed7d20e2e4f458f0999503e68.svg";
export { ForwardRef as ReactComponent };